import ee from 'event-emitter';

// eslint-disable-next-line new-cap
export const emitter = new ee();

export const showMinimumOrderModal = () => {
  emitter.emit('show-minimum-order-modal');
};
